import styled from "@emotion/styled";

import { theme } from "../../ThemeProvider/CandyTheme/ThemeShorthand";

export const MonospaceTextarea = styled.textarea(props => ({
    fontFamily: theme(props).typography.fontFamily.monospace,
    fontSize: "13px",
    width: 500,
    whiteSpace: "nowrap",
}));
